/* Copyright (C) 2018-2019 SplendidCRM Software, Inc. All Rights Reserved. 
 * Any use of the contents of this file are subject to the SplendidCRM Professional Source Code License Agreement, or other written agreement between you and SplendidCRM ("License"). 
 * SplendidCRM owns all proprietary rights, including all copyrights, patents, trade secrets, and trademarks, in and to the contents of this file.  You will not link to or in any way 
 * combine the contents of this file or any derivatives with any Open Source Code in any manner that would require the contents of this file to be made available to any third party. 
 */

export default interface DASHBOARDS_PANELS
{
	ID                            : string  ; // uniqueidentifier
	PANEL_ORDER                   : number  ; // int
	ROW_INDEX                     : number  ; // int
	COLUMN_WIDTH                  : number  ; // int
	DASHBOARD_ID                  : string  ; // uniqueidentifier
	DASHBOARD_APP_ID              : string  ; // uniqueidentifier
	NAME                          : string  ; // nvarchar
	CATEGORY                      : string  ; // nvarchar
	MODULE_NAME                   : string  ; // nvarchar
	TITLE                         : string  ; // nvarchar
	SETTINGS_EDITVIEW             : string  ; // nvarchar
	IS_ADMIN                      : boolean ; // bit
	APP_ENABLED                   : boolean ; // bit
	SCRIPT_URL                    : string  ; // nvarchar
	DEFAULT_SETTINGS              : string  ; // nvarchar
	PANEL_TYPE?                   : string  ; // nvarchar
}

